import { useEffect } from "react";
import LegalLayout from "@/components/LegalLayout";
import { PRIVACY_SECTIONS } from "@/content/legal";

export default function Privacy() {
  useEffect(() => {
    document.title = "Privacy Policy | Knot Forgotten";
  }, []);

  return (
    <div data-testid="privacy-page">
      <LegalLayout
        eyebrow="Legal"
        title="Knot Forgotten Privacy Policy"
        effective="September 21, 2026"
        updated="September 21, 2026"
        sections={PRIVACY_SECTIONS}
      >
        <p className="mt-10 border-t border-slate-200 pt-6 text-sm text-slate-500">
          This policy describes the Knot Forgotten mobile application as currently implemented. It covers
          only the data practices of the App itself — this website does not collect visitor information, use
          analytics, or run advertising trackers.
        </p>
      </LegalLayout>
    </div>
  );
}
